import type { ComponentType, SVGProps } from 'react';

import { ROUTES } from '../routes';

import { ClockIcon, HomeIcon, ProfileIcon } from './NavIcons';

export interface NavItem {
  to: string;
  /** i18n key, never a literal label. */
  labelKey: 'nav.home' | 'nav.history' | 'nav.profile';
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
}

/**
 * Three tabs, matching the floating bar in the mockup.
 *
 * The mockup's bar carries a house, a clock and an envelope. The first two map
 * straight onto Home and the money history. The envelope is "Contact the
 * support" — and Novix has no support channel wired up yet, so a tab pointing
 * at it would be a control that does nothing. The third tab is Profile instead,
 * which is exactly where the mockup puts the "Contact The Support" action
 * (Profile_1), so the destination stays reachable and nothing is invented.
 *
 * Cards and Payouts are no longer tabs. Cards is reached from "Your cards →
 * See all" on the main screen, as the mockup does it; payouts are part of the
 * merged history rather than a separate section.
 */
export const NAV_ITEMS: readonly NavItem[] = [
  { to: ROUTES.home, labelKey: 'nav.home', Icon: HomeIcon },
  { to: ROUTES.wallet, labelKey: 'nav.history', Icon: ClockIcon },
  { to: ROUTES.profile, labelKey: 'nav.profile', Icon: ProfileIcon }
];
